import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
	textArea: {
		marginTop: 8,
		width: "100%",
		minHeight: 80,
		padding: "8px",
		borderRadius: 4,
		border: "1px solid #ccc",
		fontFamily: "inherit",
		fontSize: 14,
		resize: "vertical",
		boxSizing: "border-box"
	}
})

export default useStyles
